import { yupResolver } from '@hookform/resolvers/yup';
import { KeyboardTwoTone } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import React, { FC, useCallback } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useRegistrationNationSecurityNumberSchema } from '../../validators';
import { ControlledMaskInput } from '../../../shared/components/controlled-mask-input/controlled-mask-input.component';
import { Widget } from '../../../shared';

export const StartRegistrationNationalSecurityNumber: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const form = useForm<{ nationalSecurityNumber: string }>({
        resolver: yupResolver(useRegistrationNationSecurityNumberSchema()),
    });

    const onSubmit = useCallback(
        (data: { nationalSecurityNumber: string }) => {
            navigate(`/registration/info?nationalSecurityNumber=${data.nationalSecurityNumber}`);
        },
        [navigate],
    );

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
                <Widget>
                    <Stack spacing={2} alignItems="center" justifyContent="center">
                        <KeyboardTwoTone color="primary" />
                        <Typography variant="h6">{t('nationalSecurityNumberLabel')}</Typography>
                        <ControlledMaskInput
                            name="nationalSecurityNumber"
                            mask="**.**.**-***.**"
                            placeholder={'XX.XX.XX-XXX.XX'}
                        />
                        <Button type="submit" variant="contained" size="large" fullWidth>
                            {t('startRegistration')}
                        </Button>
                    </Stack>
                </Widget>
            </form>
        </FormProvider>
    );
};
